import useBoundStore from 'store';
import BuySecondaryTabs from '../../components/buy-secondary-tabs';

const BuySecondaryStreetMap = () => {
  const selectedIds = useBoundStore((s) => Array.from(s.selectedHouseIdsSecondary));
  const setSelectedHouseIdsSecondary = useBoundStore((s) => s.setSelectedHouseIdsSecondary);

  return (
    <BuySecondaryTabs selectedIds={selectedIds} setSelectedIds={setSelectedHouseIdsSecondary} />
  );
};

export default BuySecondaryStreetMap;
